import { Component, OnInit } from '@angular/core';
import { SummitUtilService, VerbiageService } from '@summit/utils';
import { SafeHtml } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { AppUrl, WebApplicationsService } from '@summit/application-list';

@Component({
  selector: 'profile-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {

  public confirmationVerbiage: SafeHtml;
  public showReturnToQueueButton: boolean;

  constructor(
    private verbiageService: VerbiageService,
    private summitUtils: SummitUtilService,
    private webAppsService: WebApplicationsService
  ) { }

  public ngOnInit(): void {
    const variableName = this.summitUtils.getParameterByName('externalAdminAgencyNumbers') ? 'ADMIN_CONFIRMATION' : 'CONFIRMATION';
    this.verbiageService.getDataText(environment.restfulService, 'NEW_USER_REQUEST', variableName).subscribe(
      verbiage => {
        this.confirmationVerbiage = verbiage;
      }
    );
    if (this.summitUtils.getParameterByName('fromUserManagement')) {
      this.showReturnToQueueButton = true;
    }
  }

  public returnHome(): void {
    this.webAppsService.getAppUrl('HOME_PAGE', [], environment.restfulService, true)
      .subscribe((appUrl: AppUrl) => window.location.href = appUrl.url);
  }

  public returnToQueue(): void {
    this.webAppsService.getAppUrl('USER_MANAGEMENT', [], environment.restfulService, true)
      .subscribe((appUrl: AppUrl) => window.location.href = appUrl.url);
  }
}
